import React, { useMemo, useCallback } from 'react';
import { Layout, Menu, Row, Col, Dropdown } from 'antd';
import { FormattedMessage, useIntl } from 'react-intl';
import { UserOutlined, BranchesOutlined } from '@ant-design/icons';
import * as routePath from 'routers/route-path';
import { useHistory, useLocation } from 'react-router-dom';
import Cookies from 'js-cookie';
import { TOKEN } from 'constants/cookies';

import { showModalConfirmStylePrimary } from 'utilities/modal';
import { getFullName } from 'utilities/stringHelper';

import './styles.scss';
import useProfile from 'hooks/useProfile';
import { TENANT_NAME } from 'constants/common';

const { Header } = Layout;

const SiteHeader = ({ onCollapse }) => {
  const history = useHistory();
  const location = useLocation();
  const { formatMessage } = useIntl();

  const { data: userInfo, remove } = useProfile();

  const handleLogout = () => {
    showModalConfirmStylePrimary({
      title: formatMessage({ id: 'common.log_out' }),
      content: formatMessage({ id: 'header.modal.confirm_logout' }),
      cancelText: formatMessage({ id: 'common.cancel' }),
      okText: formatMessage({ id: 'common.logout' }),
      onOk: () => {
        remove();
        Cookies.remove(TOKEN);
        Cookies.remove(TOKEN, {
          domain: `.${process.env.REACT_APP_HOST_NAME}`,
        });
        history.push(routePath.LOGIN);
      },
    });
  };

  const menu = useMemo(
    () => (
      <Menu>
        <Menu.Item onClick={handleLogout}>
          <FormattedMessage id="common.log_out" />
        </Menu.Item>
      </Menu>
    ),
    []
  );

  const userBlock = useCallback(
    (userInfo) => {
      return (
        <Dropdown overlay={menu}>
          <div className="user-block">
            <UserOutlined className="mr-8" />
            <div className="user-name text-1-line">
              {getFullName(userInfo?.firstName, userInfo?.lastName)}
            </div>
          </div>
        </Dropdown>
      );
    },
    [userInfo]
  );

  const tenantMenu = useMemo(
    () => (
      <Menu>
        {
          Object.values(TENANT_NAME).map((tenant) => (
            <Menu.Item key={tenant}>
              <div onClick={() => {
                localStorage.setItem('tenantName', tenant);
                window.location.reload();
              }}>
                {tenant}
              </div>
            </Menu.Item>
          ))
        }
      </Menu>
    ),
    []
  );

  const tenantBlock = () => (
    <Dropdown overlay={tenantMenu}>
      <div className="user-block">
        <BranchesOutlined className="mr-8" />
        <div className="user-name text-1-line">
          Tenant: {localStorage.getItem('tenantName') || TENANT_NAME.TIB}
        </div>
      </div>
    </Dropdown>
  )

  const isStaffPage = location.pathname === routePath.STAFF;

  return (
    <Header id="site-header">
      <Row align="middle" gutter={[24]} style={{ height: '100%' }}>
        <Col span={2}>
          {/* <div className="collapsed" onClick={onCollapse}>
            <img src={CollappsedIcon} />
          </div> */}
        </Col>
        <Col flex="auto" />
        <Col span={16} className={'d-flex justify-content-end'}>
          <div className="mr-10"></div>
          {!isStaffPage && <div className="action mx-20">{tenantBlock()} </div>}
          <div className="action">{userBlock(userInfo)} </div>
        </Col>
      </Row>
    </Header>
  );
};

export default SiteHeader;
